export const initialState = {
  request: null,
  npwp: {},
  loading: false,
  error: null,
  errorNPWPDraft: null,
  errorNPWPRegister: null,
  usage: 2,
  usageLoading: false,
  usageError: null,
  npwpDraft: {},
  requestUser: {},
  updateNPWPWDraftUser: {},
  statusNPWPDraft: "",
  registeredNpwpID: null,
  silentUpdate: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_CREATE_NPWP_DRAFT":
      return {
        ...state,
        npwpDraft: {},
        statusNPWPDraft: "",
        errorNPWPDraft: null,
        loading: true,
      };
    case "SUCCESS_CREATE_NPWP_DRAFT":
      return {
        ...state,
        npwpDraft: action.payload.npwpDraft,
        statusNPWPDraft: "SUCCESS",
        loading: false,
      };
    case "ERROR_CREATE_NPWP_DRAFT":
      return {
        ...state,
        loading: false,
        statusNPWPDraft: "",
        errorNPWPDraft: action.error,
      };
    case "REQUEST_UPDATE_NPWP_DRAFT":
      return {
        ...state,
        updateNPWPWDraftUser: {},
        statusNPWPDraft: "",
        errorNPWPDraft: null,
        loading: true,
      };
    case "SUCCESS_UPDATE_NPWP_DRAFT":
      return {
        ...state,
        updateNPWPWDraftUser: action.payload.npwpDraft,
        statusNPWPDraft: "SUCCESS",
        loading: false,
        silentUpdate: action.payload.silent,
      };
    case "ERROR_UPDATE_NPWP_DRAFT":
      return {
        ...state,
        loading: false,
        statusNPWPDraft: "",
        errorNPWPDraft: action.error,
      };
    case "REQUEST_REGISTER_NPWP":
      return {
        ...state,
        request: action.payload.request,
        loading: true,
        errorNPWPRegister: null,
      };
    case "REQUEST_REGISTER_NPWP_SUCCESS":
      return {
        ...state,
        request: null,
        loading: false,
        registeredNpwpID: action.payload.registeredNpwpID,
      };
    case "REQUEST_REGISTER_NPWP_ERROR":
      return {
        ...state,
        request: null,
        loading: false,
        errorNPWPRegister: action.error,
      };
    case "CLEAR_UPADTE_NPWP_DRAFT":
      return {
        ...state,
        statusNPWPDraft: "",
      };
    case "CLEAR_REGISTER_NPWP":
      return {
        ...state,
        registeredNpwpID: null,
      };
    case "REQUEST_GET_NPWP_STATUS":
      return {
        ...state,
        request: action.payload.request,
        loading: true,
        error: null,
      };
    case "GET_NPWP_STATUS_SUCCESS":
      return {
        ...state,
        request: null,
        npwp: action.payload.npwp,
        usage: state.usage < 2 ? state.usage + 1 : state.usage,
        loading: false,
      };
    case "GET_NPWP_STATUS_ERROR":
      return {
        ...state,
        request: null,
        loading: false,
        error: action.error,
      };
    case "REQUEST_LIST_NPWP_USAGE":
      return {
        ...state,
        request: action.payload.request,
        usage: 2,
        usageError: null,
        usageLoading: true,
      };
    case "LIST_NPWP_USAGE_SUCCESS":
      return {
        ...state,
        request: null,
        usage: action.payload.usage,
        usageLoading: false,
      };
    case "LIST_NPWP_USAGE_ERROR":
      return {
        ...state,
        request: null,
        usageLoading: false,
        usageError: action.error,
      };
    case "CLEAR_NPWP_ERROR":
      return {
        ...state,
        error: null,
        usageError: null,
      };
    case "CLEAR_NPWP":
      return {
        ...state,
        npwp: {},
      };
    default:
      return state;
  }
};
